var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "#ADB1C9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8367 9.35551C15.31 9.82953 15.3224 10.6074 14.8367 11.0814L11.2705 14.5618H20.7729C24.212 14.5618 26.9999 17.2827 26.9999 20.639V24.2556C26.9999 24.9269 26.4423 25.4711 25.7545 25.4711C25.0667 25.4711 24.5091 24.9269 24.5091 24.2556V20.639C24.5091 18.6252 22.8364 16.9927 20.7729 16.9927H11.2294L14.8367 20.5132C15.3224 20.9872 15.3224 21.7529 14.8367 22.227C14.351 22.701 13.5664 22.701 13.0807 22.227L7.36428 16.6481C6.87857 16.1741 6.87857 15.4084 7.36428 14.9344L13.0807 9.35551C13.5664 8.8815 14.351 8.8815 14.8367 9.35551Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/Undo.e437c835.svg";
export { ForwardRef as ReactComponent };